<div>
  <ul
    id="detail_veroeffentlichungsinfos_marg"
    class="d-block d-md-flex justify-content-start p-0 mb-0"
  >
    <li class="d-flex flex-column justify-content-between mb-1 me-0 me-md-3">
      <span id="detail_veranstaltungid_label" class="fw-bold pe-1 text-nowrap"
        >Veranstaltungs-ID</span
      >
      <span id="detail_veranstaltungid">{{ termin.id }}</span>
    </li>

    @if (termin.aktualisierungsdatum; as timestamp) {
      <li class="d-flex flex-column justify-content-between mb-1 me-0 me-md-3">
        <span id="detail_aktualisierungsdatum_label" class="fw-bold pe-1 text-nowrap"
          >Aktualisierungsdatum</span
        >
        <span id="detail_aktualisierungsdatum">{{ timestamp | date }}</span>
      </li>
    }

    <li class="d-flex flex-column justify-content-between mb-1 me-0 me-md-3">
      <span id="detail_anbieterid_label" class="fw-bold pe-1 text-nowrap">Anbieter-ID</span>
      <span id="detail_anbieterid">{{ termin.angebot.bildungsanbieter.id }}</span>
    </li>
  </ul>
</div>
@if (termin?.eigeneAngebotsnummer; as fremdId) {
  <div class="col d-flex flex-row flex-md-column justify-content-between mb-1">
    <span id="_marg_wbinfo_fremdId_label" class="fw-bold col-8"
      >Angebotsnummer des Bildungsanbieters</span
    >
    <span id="_marg_wbinfo_fremdId" class="col-4 text-end text-md-start">{{ fremdId }}</span>
  </div>
}
